<script>
import messages from '@/mixins/messages'
import VoucherResource from '@/resources/voucher'

export default {
    name: 'VoucherBalanceForm',
    mixins: [messages],
    data() {
        return {
            loading: false,
            balance: null,
            voucherCode: '',
        }
    },
    methods: {
        async onSubmit() {
            try {
                const voucherResource = new VoucherResource({ id: this.voucherCode })
                this.balance = await voucherResource.getBalance()
            } catch(e) {
                throw this.axiosExtract(e, {
                    404: 'Voucher code not found!'
                })
            } finally {
                this.loading = false
            }
        },
        onBack() {
            this.balance = null
            this.voucherCode = ''
        }
    },
}
</script>

<template>
    <div class="voucher-balance-form">
        <b-row>
            <b-col>
                <b-form @submit.prevent="onSubmit" v-if="!balance">
                    <b-form-group label="Gutscheincode" label-cols-md="4">
                        <b-form-input v-model="voucherCode"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols-md="4">
                        <b-button type="submit" :disabled="!this.voucherCode">Kontostand prüfen</b-button>
                    </b-form-group>
                </b-form>

                <div v-else>
                    <b-alert variant="success" show>Der Kontostand dieses Gutscheins beträgt <strong>{{ currencySymbol() }}{{ moneyFormat(balance) }}</strong></b-alert>
                    <a href="javascript:{}" @click="onBack"><b-icon icon="arrow-left-short" /> Einen anderen Code prüfen</a>
                </div>

                <messages />
            </b-col>
        </b-row>
    </div>
</template>

<style lang="scss">
</style>
